import React from 'react'
import { ImHome3 } from 'react-icons/im'
import { MdFaceRetouchingNatural } from 'react-icons/md'
import { BsInfoLg } from 'react-icons/bs' 
import { GrMail } from 'react-icons/gr' 
import { FaLaptopCode } from 'react-icons/fa' 
import { GiStarsStack } from 'react-icons/gi' 
import { HiChevronRight } from 'react-icons/hi'



const NavigationDots = ({ active }) => {
  return (
    <div className="app__navigation">
        {/* {['home', 'about', 'work', 'skills', 'testimonials', 'contact'].map((item, index) => (
            <a 
                href={`#${item}`}
                key={item + index} 
                className="app__navigation-dot"
                style={active === item ? { backgroundColor: '#313BAC'} : { }}
            />
        ))} */}
            <div className="app__navigation-inner">


            {/* home */}
            <a 
                href={'#home'}
                key={'home' + '1'} 
                className="app__navigation-dot"
                style={active === 'home' ? { backgroundColor: '#cbcbcb' } : { }}
                // style={active === 'home' ? { backgroundColor: '#cbcbcb', boxShadow: '0 0 10px rgba(0, 0, 0, 1)' } : { }}
            >
              <ImHome3 color='#fff' />
            </a>


            {/* about */}
            <a 
                href={'#about'}
                key={'about' + '2'} 
                className="app__navigation-dot"
                style={active === 'about' ? { backgroundColor: '#cbcbcb'} : { }}
            >
              <BsInfoLg color='#fff' />
            </a>


            {/* work */}
            <a 
                href={'#work'}
                key={'work' + '3'} 
                className="app__navigation-dot"
                style={active === 'work' ? { backgroundColor: '#cbcbcb'} : { }}
            >
              <FaLaptopCode color='#fff' />
            </a>


            {/* skills */}
            <a 
                href={'#skills'}
                key={'skills' + '4'} 
                className="app__navigation-dot"
                style={active === 'skills' ? { backgroundColor: '#cbcbcb'} : { }}
            >
              <GiStarsStack color='#fff' />
            </a>


            {/* testimonial */}
            {/* <a 
                href={'#testimonial'}
                key={'testimonial' + '5'} 
                className="app__navigation-dot"
                style={active === 'testimonial' ? { backgroundColor: '#cbcbcb'} : { }}
            >
              <MdFaceRetouchingNatural color='#fff' />
            </a> */}


            {/* contact */}
            <a 
                href={'#contact'}
                key={'contact' + '6'} 
                className="app__navigation-dot"
                style={active === 'contact' ? { backgroundColor: '#cbcbcb'} : { }}
            >
              <GrMail color='#fff' />
            </a>
          
        </div>
    </div>
  )
}

export default NavigationDots